import React from 'react';
import { CTAButton } from './CTAButton';
import { ScarcityBlock } from './ScarcityBlock';
export function FinalChoice() {
  return <section className="border-b border-line bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-109" data-mp="31z14v66uap0d">
      <h2 className="mx-auto max-w-2xl text-center font-display text-[28px] font-extrabold leading-[1.12] tracking-tight text-white sm:text-4xl" data-id="element-110" data-mp="2nyqb9ve5awbi">
        La prochaine fois qu’un patient arrivera avec une créatinine élevée…
      </h2>
      <p className="mt-4 text-center text-[15px] text-slate-400" data-id="element-111" data-mp="3fqxt2z5e0erh">Vous aurez deux options.</p>

      <div className="mx-auto mt-8 grid w-full max-w-3xl grid-cols-1 gap-4 sm:grid-cols-2" data-id="element-112" data-mp="3kn601p9fl1nk">
        <div className="rounded-2xl border border-line bg-surface p-5" data-id="element-113" data-mp="36wapm8jaachv">
          <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-slate-500" data-id="element-114" data-mp="3ax3178fmothb">
            Option 1
          </span>
          <p className="mt-3 text-[15px] leading-relaxed text-slate-400" data-id="element-115" data-mp="2h1hxuiw1t2s">
            Continuer à chercher des réponses dans plusieurs guides et prendre vos décisions dans
            l’incertitude.
          </p>
        </div>
        <div className="rounded-2xl border border-lime/40 bg-[#0C1810] p-5" data-id="element-116" data-mp="2vlmhm29sfqpw">
          <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-lime" data-id="element-117" data-mp="2vjjh2ob0ef6x">
            Option 2
          </span>
          <p className="mt-3 text-[15px] font-semibold leading-relaxed text-white" data-id="element-118" data-mp="35k27y30zqvyc">
            Ouvrir Route Maladie Rénale™ et savoir exactement quelle est la prochaine étape.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-10 max-w-xl" data-id="element-119" data-mp="3fa51q5fxsdxq">
        <CTAButton label="Je veux accéder maintenant à la Route Rénale™" caption="Téléchargement immédiat • Paiement unique • Accès à vie • Garantie de 7 jours" data-id="element-120" data-mp="3f9c2dpjb4qpm" />
      </div>

      <div className="mt-8" data-id="element-121" data-mp="3o8770x6pdsqt">
        <ScarcityBlock data-id="element-122" data-mp="1yv3oskgilrq4" />
      </div>
    </section>;
}